import { useEffect, useState } from 'react';
import moment from "moment";
import momentTimezone from "moment-timezone";

export const useCountryNameBasedOnTimezone = () => {
  
    const [countryName, setCountryName] = useState("");

    const getCountryName = () => {

        let timezone = moment.tz.guess();

        if(timezone?.toLowerCase()?.includes('calcutta')) {
            timezone = 'Asia/Kolkata';
        }

        const last = timezone?.split('/');
        if(last.length > 1) {
            timezone = last?.[last.length - 1];
        }

        const countries = require("moment-timezone/data/meta/latest.json");
        const zones = countries?.zones;
        const countryList = countries?.countries;
        const countryCodeList = Object.values(zones).find(a => a?.name?.toLowerCase()?.includes(timezone?.toLowerCase()))?.countries;
        let countryName = "";
        countryCodeList?.forEach(a => {
            if(countryName === "" && countryList[a]) {
                countryName = countryList[a]?.name;
            }
        })
        setCountryName(countryName);
    };

    useEffect(getCountryName, []);
    window.getCountryName = getCountryName;

    return { countryName: countryName };

}
